import store from '@/store/index';
import { textSize } from '../../utils/textSize';
import { getContentWidth } from '@/utils/contentWidth';
import { BaseSubject } from '../BaseSubject.model';
import { PADDING_TOP, THS } from '../constant';

// const TAG_P_HEIGHT = TAG_P_HEIGHT; // 一个p元素的固定高度
import { TAG_P_HEIGHT } from '@/subjects/constant';
import { resolvePseudoContent } from '@/utils/html2pdf/html2canvas';
import { Message } from 'element-ui';
const TH_HEIGHT = 40; //标题高度
const MARGIN_BOTTOM = 10; // 每个页面底部空白的高度值为10px
const MIN_FILL_HEIGHT = 94; // 最小填充高度，如果不足就分页
export const XTH_TYPE_KONG = '(空)';
const XTH_TYPE_NUMBER = '①';
const XTH_TYPE_EN = 'a';
const XTH_TYPE_I = 'Ⅰ';
const SMALL_BLANK = '<input type="text" disabled style="width: 47px; height: 30px; position: absolute; right: -58px; bottom: -2.6px;background: #fff;border: 1px solid #999;"/>';
// const SMALL_BLANK = '<h2>哈哈哈</h2>';
const SMALL_BLANK_Width = 50;


interface XTHItem {
  //小题号item
  label: string;
  value: string;
}
interface XThType {
  '①': Array<string>;
  a?: Array<string>;
  Ⅰ?: Array<string>;
  '(空)'?: any;
  '(1)'?: any;
}
/**
 * 填空题
 */
export class BlankModel extends BaseSubject {
  static xThType: XThType | any = {
    '(空)': [],
    '①': ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'],
    a: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'],
    Ⅰ: ['Ⅰ', 'Ⅱ', 'Ⅲ', 'Ⅳ', 'Ⅴ', 'Ⅵ', 'Ⅶ', 'Ⅷ', 'Ⅸ', 'Ⅹ', 'Ⅺ', 'Ⅻ'],
    '(1)': ['(1)', '(2)', '(3)', '(4)', '(5)', '(6)', '(7)', '(8)', '(9)', '(10)', '(11)', '(12)'],
  };

  /**
   * 题目列表
   */
  items: { no: number; xth?: string; score: any; columnCount: any; tCount: any; value: any }[] = [];
  /**
   * 列数
   */

  columnCount: number;
  tCount: number;
  rowCount: number = 0;
  cacheInnerHTML: string = '';
  xTHValue: string = '(空)'; // 小题号的值 小题号默认为空 如果是空则代表没有小题号
  xThs: Array<XTHItem> = [
    { label: '(空)', value: '(空)' },
    { label: '(1)', value: '(1)' },
    { label: '①', value: '①' },
    { label: 'Ⅰ', value: 'Ⅰ' },
    { label: 'a', value: 'a' },
  ]; // 小题号默认的列表
  eachBlankScore: boolean = false; // 每空给分
  constructor(obj?: {
    tCount?: number;
    columnCount?: number;
    name?: string;
    type?: any;
    start?: any;
    end?: any;
    score?: any;
    value?: any;
    th?: any;
    items?: any[];
    innerHTML?: string;
    totalScore?: number;
    rows: any[];
    eachBlankScore?: boolean;
  }) {
    super(obj);
    obj = obj || { rows: [] };
    this.type = obj.type || 1; // 标识填空题
    this.name = obj.name || '填空题'; // 默认名称
    this.columnCount = obj.columnCount || 2;
    this.score = obj.score || 2;
    this.tCount = obj.tCount || 1;
    this.totalScore = obj.totalScore || 0;
    //@ts-ignore
    let acCardYJType = store.state.answerPanel.answerSheet.acCardYJType;

    this.eachBlankScore = obj.eachBlankScore && acCardYJType == 0 ? true : false;
    //†
    if (obj.items && obj.items.length) {
      this.items = obj.items;
      this.innerHTML = obj.innerHTML;
    } else {
      for (let index = obj.start; index <= obj.end; index++) {
        this.items.push({
          no: index,
          score: obj.score,
          value: obj.value || 1,
          columnCount: obj.columnCount || 2,
          tCount: obj.tCount || 1,
        });
      }
    }
    this.rows = obj.rows;
  }

  render(options: any = {}) {
    // this.cacheInnerHTML = this.innerHTML;
    //@ts-ignore
    let { acCardYJType } = store.state.answerPanel.answerSheet;;

    acCardYJType != 0 ? this.evergeRender(options) : this.personModelRender(options)
    return;
   
  }
  // 手批模式
  personModelRender(options: any = {}){
    const { hurdleReset, eachBlankScore } = options; // 不是通过二栏三栏render的
    // var container: any = document.querySelector('.basics');
    // var containerWidth: any = container.offsetWidth - 24 - 42,
    let nbNode = document.querySelector('.text-size-dom')
    let nbWidth = nbNode ? nbNode.getBoundingClientRect().width : 0
    this.computedScoreAndTH();
    var nbSize = textSize('&nbsp;'); // 360安全浏览器 计算的是4 谷歌及360极速浏览器（谷歌内核）计算的是4.21875
    nbSize = nbWidth || 4.41875 || Math.floor(nbSize);
    var containerWidth = getContentWidth(); // 获取容器宽度
    let rows: any[] = [];
    let columnWidth = containerWidth / this.columnCount;
    if (this.eachBlankScore) {
      columnWidth = columnWidth - SMALL_BLANK_Width;
    }
    // 减去分隔空格
    columnWidth = columnWidth - (this.columnCount - 1) * nbSize * 4;
    //
    for (let index = 0; index < this.items.length; index++) {
      let item = this.items[index],
        itemPrev = this.items[index - 1],
        itemColumnValue = Number(item.tCount),
        // 这里改成题号 小题号固定宽度 是为了 填空题增添每题给分的时候固定位置统一
        thStr = `<span class="str-th"  style="display: inline-block;font-family: '宋体' !important;">${(itemPrev && itemPrev.no) != item.no ? item.no + '.' : ''}${item.xth || ''}&nbsp;</span>`,
        emptyThStr = `<span class="empty-th" style="display: inline-block;font-family: '宋体' !important;">&nbsp;</span>`;
      // thStr = `${item.no + '.'}${item.xth || ''}&nbsp;&nbsp;`;
      let thWidth = textSize(thStr);
      //
      for (let x = 0; x < itemColumnValue; x++) {
        var columnHtml = '',
          nbCount = 0;
        //
        nbCount = Math.floor((columnWidth - thWidth) / nbSize)
        if (!x) {
          columnHtml = thStr + `<span class="fill-item column-width" style="margin-right: ${this.eachBlankScore ? 47 : 0}px;text-decoration: underline;position: ${this.eachBlankScore ? 'relative' : 'static'};font-family: '宋体' !important;">&#8203;&nbsp;`;
          // nbCount = Math.floor((columnWidth - thWidth) / nbSize)
        } else {
          // 这里改成题号 小题号固定宽度 是为了(eachBlankScore为true 添加每题给分) 填空题增添每题给分的时候固定位置统一
          if (this.eachBlankScore) {
            columnHtml = emptyThStr + `<span class="fill-item column-width-th-1" style="margin-right: ${this.eachBlankScore ? 47 : 0}px;text-decoration: underline;position: relative;font-family: '宋体' !important;">&#8203;&nbsp;`;
            // nbCount = Math.floor((columnWidth - thWidth) / nbSize);
          } else {
            columnHtml = `<span class="fill-item column-width-th-2"  style="margin-right: ${this.eachBlankScore ? 47 : 0}px;text-decoration: underline;font-family: '宋体' !important;">&#8203;&nbsp;`;
            // nbCount = Math.floor(columnWidth / nbSize) - 3;
          }
        }
        let columnHtmls = []
        for (let y = 0; y < nbCount; y++) {
          columnHtml += '&nbsp;';
          columnHtmls.push('1')
        }
        console.log('columnHtmls====log', columnHtmls.length);

        if (
          this.columnCount < 2 ||
          (rows[rows.length - 1] && rows[rows.length - 1].length == this.columnCount - 1)
        ) {
          columnHtml += this.getSMALL_BLANK(this.eachBlankScore) + '</span> ';
        } else {
          columnHtml += `${this.getSMALL_BLANK(this.eachBlankScore)}</span>&nbsp;&nbsp;&nbsp;`;
        }

        if (rows.length && rows[rows.length - 1].length < this.columnCount) {
          rows[rows.length - 1].push(columnHtml);
        } else {
          rows.push([columnHtml]);
        }
      }
    }
    let os = getOS()
    let os_class=""
    if(os == 'macos') {
      os_class = os
    }
    this.rows = rows.map((r: any) => `<p>${r.join('')}</p>`);
    this.rows.unshift(`<p>${this.th}.${this.name}</p>`);
    // 这里this.innerHTML有三种i情况 1是第一次初始化 的确需要赋值  2是自定义编辑之后render方法执行 这里的this.innerHTML用已经存储的this.innerHTML
    // 这里最重要注意的就是 如果来自编辑的是当前的题型 字段fromEdit判断是否是当前编辑的 则不可能保存之前的高度和html 只能重新更新题型
    if (!hurdleReset && this.innerHTML && this.innerHTML.length && !this.fromEdit) {
      this.cacheInnerHTML = this.innerHTML;
      return console.log('当前html有值的情况');
    } else {
      this.cacheInnerHTML = this.innerHTML = `<p class='row ${os_class}'>${rows
        .map((r: any) => r.join(''))
        .join('</p><p class="row row-blank ">')}</p>`;
      this.rowCount = this.rows.length;
    }
  }
  // 均分
  evergeRender(options: any = {}) {
    const { hurdleReset,eachBlankScore } = options; // 不是通过二栏三栏render的
    // var container: any = document.querySelector('.basics');
    // var containerWidth: any = container.offsetWidth - 24 - 42,
    // this.computedScoreAndTH();
    let nbNode = document.querySelector('.text-size-dom')
    let nbWidth = nbNode ? nbNode.getBoundingClientRect().width : 0
    this.computedScoreAndTH();
    var nbSize = textSize('&nbsp;'); // 360安全浏览器 计算的是4 谷歌及360极速浏览器（谷歌内核）计算的是4.21875
    nbSize = nbWidth || 4.41875 || Math.floor(nbSize);
    var containerWidth = getContentWidth(); // 获取容器宽度
    let rows: any[] = [];
    let columnWidth = containerWidth / this.columnCount;
    if(this.eachBlankScore) {
      columnWidth = columnWidth - SMALL_BLANK_Width;
    }
    columnWidth = columnWidth - (this.columnCount - 1) * nbSize * 4;
    let os = getOS()
    let os_class=""
    if(os == 'macos') {
      os_class = os
    }
    for (let index = 0; index < this.items.length; index++) {
      let item = this.items[index],
        itemPrev = this.items[index-1],
        itemColumnValue = Number(item.tCount),
        // 这里改成题号 小题号固定宽度 是为了 填空题增添每题给分的时候固定位置统一
        thStr = `<span class="str-th" style="display: inline-block">${(itemPrev && itemPrev.no )!= item.no ?  item.no + '.' : ''}${item.xth || ''}&nbsp;</span>`,
        emptyThStr = `<span class="empty-th" style="display: inline-block">&nbsp;</span>`;
        // thStr = `${item.no + '.'}${item.xth || ''}&nbsp;&nbsp;`
      let thWidth = textSize(thStr);
      for (let x = 0; x < itemColumnValue; x++) { 
        var columnHtml = '',
          nbCount = 0;
          // 每空长度  = 均分长度 - 公摊部分（间隔 + 小题占用空间 + 末尾换行）
          if(os == 'macos'){
            let width = (containerWidth - (this.columnCount - 1) * nbSize * 4 - (Math.ceil(item.columnCount / itemColumnValue) * thWidth) - 12) / this.columnCount;
            nbCount =  Math.floor(width / nbSize) - 2
            
          }else{
            let width = (containerWidth - (this.columnCount - 1) * nbSize  - (Math.ceil(item.columnCount / itemColumnValue) * thWidth) - 12) / this.columnCount;
            nbCount =  Math.floor(width / nbSize)
          }

          //          
        if (!x) {
          columnHtml = thStr + `<span class="fill-item" style="padding-top:15px;margin-right: ${this.eachBlankScore ? 0 : 0}px;text-decoration: underline;position: ${this.eachBlankScore ? 'relative' : 'static'}">&#8203;`;
          // nbCount = Math.floor((columnWidth - thWidth) / nbSize) - 3;
        } else {
          // 这里改成题号 小题号固定宽度 是为了(eachBlankScore为true 添加每题给分) 填空题增添每题给分的时候固定位置统一
          if(this.eachBlankScore) {
            columnHtml = emptyThStr + `<span class="fill-item" style="padding-top:15px;margin-right: ${this.eachBlankScore ? 0 : 0}px;text-decoration: underline;position: relative;">&#8203;`;
            // nbCount = Math.floor((columnWidth - thWidth) / nbSize) - 3;
          } else {
            columnHtml = emptyThStr + `<span class="fill-item" style="padding-top:15px;margin-right: ${this.eachBlankScore ? 0 : 0}px;text-decoration: underline;">&#8203;`;
            // nbCount = Math.floor(columnWidth / nbSize) - 3;
          }
        }
        for (let y = 1; y < nbCount; y++) {
          columnHtml += '&nbsp;';

        }
        if (
          this.columnCount < 2 ||
          (rows[rows.length - 1] && rows[rows.length - 1].length == this.columnCount - 1)
        ) {
          columnHtml += this.getSMALL_BLANK(this.eachBlankScore) +'</span>' ;
        } else {
          columnHtml += `${this.getSMALL_BLANK(this.eachBlankScore)}</span>&nbsp;`;
        }

        if (rows.length && rows[rows.length - 1].length < this.columnCount) {
          rows[rows.length - 1].push(columnHtml);
        } else {
          rows.push([columnHtml]);
        }
      }
    }

    this.rows = rows.map((r: any) => `<p>${r.join('')}</p>`);
    this.rows.unshift(`<p>${this.th}.${this.name}</p>`);
    // 这里this.innerHTML有三种i情况 1是第一次初始化 的确需要赋值  2是自定义编辑之后render方法执行 这里的this.innerHTML用已经存储的this.innerHTML
    // 这里最重要注意的就是 如果来自编辑的是当前的题型 字段fromEdit判断是否是当前编辑的 则不可能保存之前的高度和html 只能重新更新题型
    if (!hurdleReset && this.innerHTML && this.innerHTML.length && !this.fromEdit) {
      this.cacheInnerHTML = this.innerHTML;
      return console.log('当前html有值的情况', this.innerHTML);
    } else {
      this.cacheInnerHTML = this.innerHTML = `
        <p class='row ${os_class}'>
          ${rows
            .map((r: any) => r.join(''))
            .join(`</p><p class="row row-blank ${os_class}">`)}
        </p>
      `;
      this.rowCount = this.rows.length;
    }
  }

  getSMALL_BLANK(eachBlankScore: boolean): string {
    if (eachBlankScore) {
      return SMALL_BLANK;
    } else {
      return '';
    }
  }

  computedScoreAndTH(unComputedTH?: boolean) {
    this.totalScore = 0;
    this.items.forEach(item => {
      this.totalScore! += Number(item.score);
    });
    if (unComputedTH) {
      return;
    }
    if (this.items.length > 1) {
      this.start = this.items[0].no;
      this.end = this.items[this.items.length - 1].no;
    } else {
      this.start = this.items[0].no;
      this.end = this.items[0].no;
    }
  }
  // 追加
  addItems(obj: any): boolean {
    if (this.beforeAddItems()) {
      Message({
        message: "相同小题已经存在,请勿重复添加！",
        type: "warning",
        customClass: "mzindex",
      });
      return false;
    }
    this.addXthItems(obj);
    this.addNoXthItems(obj);
    return true;
    // this.items.sort((a: any, b: any) => {
    //   return a.no - b.no;
    // });
  }
  deleteItem(index: number) {
    this.items.splice(index, 1);
    this.computedScoreAndTH(true);
  }

  /**
   *
   * push 有小题号的数组item 就是题型设置的时候 小题号设置不为空
   * @param obj
   */
  addXthItems(obj: any): boolean {
    if (obj.xTHValue !== XTH_TYPE_KONG) {
      for (let idx = Number(obj.start); idx <= Number(obj.end) - 1 + Number(obj.start); idx++) {
        obj.items &&
          this.items.push({
            no: obj.start,
            xth:
              (BlankModel.xThType[obj.xTHValue].length &&
                BlankModel.xThType[obj.xTHValue][idx - obj.start]) ||
              '',
            score: obj!.score,
            columnCount: obj!.columnCount,
            value: idx,
            tCount: obj!.tCount,
          });
      }
    }
    return true;
  }
  /**
   * push 没有小题号的数组item 就是题型设置的时候 小题号设置为空
   * @param obj
   */
  addNoXthItems(obj: any): boolean {
    // const hash: any = {};
    if (obj.xTHValue === XTH_TYPE_KONG) {
      for (let idx = Number(obj.start); idx <= Number(obj.end); idx++) {
        obj.items &&
          this.items.push({
            no: idx,
            xth: '',
            score: obj!.score,
            columnCount: obj!.columnCount,
            value: idx,
            tCount: obj!.tCount,
          });
      }
      // this.items = this.items.reduce((item: any, next: any) => {
      //   hash[next.no] ? '' : (hash[next.no] = true && item.push(next));
      //   return item;
      // }, []); // 对象数组去重
    }
    return true;
  }

  /**
   * 在添加无小题号列表之前的校验 二级题号不能重复
   * @returns {boolean} 返回是否存在相同题号
   */
  beforeAddItems(): boolean {
    return this.items.some((item, index: number) => {
      return item.no == this.start;
    });

  }

  appendToPage(
    state: any,
    // pageCell: { contentHeight: number; value: string[] }[],
    pageHeight: number,
    newTopicHeight: number
  ) {
    // this.rows.forEach(row => this.insertToPage(pageCell, row, pageHeight));
    let currentPage = state.pageCell.length - 1;
    // 判断添加题目时是否存在最小填充高度
    if (this.page.isSurplusPage(state, currentPage, TH_HEIGHT + TAG_P_HEIGHT + 20)) {
      state.pageCell[state.pageCell.length - 1].fillTopiclist.push({
        name: this.name,
        editName: this.editName,
        eachBlankScore: this.eachBlankScore,
        totalScore: this.totalScore,
        start: this.start,
        end: this.end,
        th: this.th,
        type: this.type,
        hasTitle: true,
        initDragHeight: this.initDragHeight || (this.rowCount - 1) * TAG_P_HEIGHT,
        innerHTML: this.cacheInnerHTML,
      });
      newTopicHeight = this.initDragHeight || (this.rowCount - 1) * TAG_P_HEIGHT + MARGIN_BOTTOM;
      this.recursionCutPage(state, newTopicHeight, currentPage, state.existHeight); //2 是2个像素的上下边距
    } else {

      let topicHeight = newTopicHeight + TH_HEIGHT;
      this.page.createNextPage(state.pageCell);
      currentPage++;
      this.page.insertNextPageHeadStack(
        state.pageCell[currentPage],
        topicHeight,
        this.type,
        this.cacheInnerHTML,
        {
          name: this.name,
          eachBlankScore: this.eachBlankScore,
          totalScore: this.totalScore,
          start: this.start,
          end: this.end,
          th: this.th,
          type: this.type,
          hasTitle: true,
          initDragHeight: this.initDragHeight || (this.rowCount - 1) * TAG_P_HEIGHT,
          innerHTML: this.cacheInnerHTML,
        }
      );
      newTopicHeight = this.initDragHeight || (this.rowCount - 1) * TAG_P_HEIGHT + MARGIN_BOTTOM;
      this.recursionCutPage(state, newTopicHeight, currentPage, 0);
    }
  }
  resetPage(state: any,) {
    let newTopicHeight = 0
    let currentPage = state.pageCell.length - 1;
    // 判断添加题目时是否存在最小填充高度
    if (this.page.isSurplusPage(state, currentPage, TH_HEIGHT + TAG_P_HEIGHT + 20)) {
      state.pageCell[state.pageCell.length - 1].fillTopiclist.push({
        name: this.name,
        editName: this.editName,
        eachBlankScore: this.eachBlankScore,
        totalScore: this.totalScore,
        start: this.start,
        end: this.end,
        th: this.th,
        type: this.type,
        hasTitle: true,
        initDragHeight: this.initDragHeight || (this.rowCount - 1) * TAG_P_HEIGHT,
        innerHTML: this.cacheInnerHTML,
      });
      newTopicHeight = this.initDragHeight || (this.rowCount - 1) * TAG_P_HEIGHT + MARGIN_BOTTOM;
      this.recursionCutPage(state, newTopicHeight, currentPage, state.existHeight); //2 是2个像素的上下边距
    } else {

      let topicHeight = newTopicHeight + TH_HEIGHT;
      this.page.createNextPage(state.pageCell);
      currentPage++;
      this.page.insertNextPageHeadStack(
        state.pageCell[currentPage],
        topicHeight,
        this.type,
        this.cacheInnerHTML,
        {
          name: this.name,
          eachBlankScore: this.eachBlankScore,
          totalScore: this.totalScore,
          start: this.start,
          end: this.end,
          th: this.th,
          type: this.type,
          hasTitle: true,
          initDragHeight: this.initDragHeight || (this.rowCount - 1) * TAG_P_HEIGHT,
          innerHTML: this.cacheInnerHTML,
        }
      );
      newTopicHeight = this.initDragHeight || (this.rowCount - 1) * TAG_P_HEIGHT + MARGIN_BOTTOM;
      this.recursionCutPage(state, newTopicHeight, currentPage, 0);
    }
  }
  /**
   * 递归更新纸张的高度（每次判断当前纸张的高度是否超过，超过则递归裁剪高出的元素）
   */
  recursionCutPage(
    state: any,
    newTopicHeight: number,
    currentPage: number,
    existHeight: number,
    isSelfCall?: boolean
  ) {
    //@ts-ignore
    let { acCardYJType } = store.state.answerPanel.answerSheet;;
    let cardGapHeight = acCardYJType == 2 ? 34 : 0
    existHeight = existHeight + (isSelfCall ? 0 : TH_HEIGHT) + cardGapHeight;
    // existHeight = existHeight + TH_HEIGHT;
    const currentMaxHeight = state.pageCell[currentPage].contentHeight;
    const canFillHeight = currentMaxHeight - existHeight; // 可填充高度
    let topicHeight = newTopicHeight + (isSelfCall ? 0 : TH_HEIGHT);
    const currentTopicStack =
      state.pageCell[currentPage].fillTopiclist[
      state.pageCell[currentPage].fillTopiclist.length - 1
      ];
    if (topicHeight > canFillHeight) {
      // this.cutOverHeight();
      const { resolveHtml, resolveHeight } = this.addrResolveTopic(
        this.cacheInnerHTML,
        canFillHeight - cardGapHeight,
        currentTopicStack
      );
      this.cacheInnerHTML = resolveHtml;
      topicHeight -= (resolveHeight || canFillHeight);
      newTopicHeight = topicHeight;
      currentTopicStack.initDragHeight = canFillHeight;
      if (topicHeight < TAG_P_HEIGHT && !resolveHtml) {
        //  剩余高度不足以跨页展示
        currentTopicStack.isHurdle = false;
        return;
      } else {
        currentTopicStack.isHurdle = true;
      }
      this.page.createNextPage(state.pageCell);
      // state.currentPageNum++;
      currentPage++;
      this.page.insertNextPageHeadStack(
        state.pageCell[currentPage],
        topicHeight,
        this.type,
        this.cacheInnerHTML,
        this
      );
      this.recursionCutPage(state, newTopicHeight, currentPage, 0, true);
    } else {
      // this.addrResolveTopic(this.cacheInnerHTML, topicHeight, currentTopicStack);
      currentTopicStack.initDragHeight = Math.floor(topicHeight / TAG_P_HEIGHT) * TAG_P_HEIGHT; //直接将剩余的高度复制给最后
      // currentTopicStack.initDragHeight = isSelfCall
      //   ? topicHeight + MARGIN_BOTTOM
      //   : topicHeight - TH_HEIGHT + MARGIN_BOTTOM; //直接将剩余的高度复制给最后
      currentTopicStack.isHurdle = false;
      currentTopicStack.innerHTML = this.cacheInnerHTML;
      // state.loadingInstance.close();
      return console.log('停止递归', currentPage);
    }
  }

  addrResolveTopic(innerHTML: string, canFillHeight: number, currentTopicStack: any): any {
    try {
      let ptags = innerHTML.split('</p>');
      ptags.pop();
      ptags = ptags.map(ptag => {
        return ptag + '</p>';
      });
      const dragPTags = Math.floor((canFillHeight - PADDING_TOP) / TAG_P_HEIGHT); // 拖拽高度四舍五入转换到p元素的个数
      const hurdleTags = ptags.splice(0, dragPTags); //剩余的数组 数组反转然后切割跨栏的小题
      // const result = ptags.join('');
      currentTopicStack.innerHTML = hurdleTags.join('');
      currentTopicStack.isResolved = true; //设置当前分解stack题型是否是分解
      let resolveHeight = dragPTags * TAG_P_HEIGHT;
      return {
        resolveHtml: ptags.join(''),
        resolveHeight: resolveHeight,
      }
      return ptags.join('');
      // return result;
    } catch (e) {
      console.error('分解题型报错', e.message);
    }
  }

}
function getOS(){
  const platform = navigator.platform.toLowerCase()
  
  if (platform.includes('mac')) return 'macos'
  if (platform.includes('win')) return 'windows'
  if (platform.includes('linux')) return 'linux'
  
  return 'unknown'
}